module.exports = __webpack_public_path__ + "img/piggy-bank.f8858655.svg";